import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';
import {UntypedFormControl} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {CommonService} from '@services/common.service';
import {MatDialog} from '@angular/material/dialog';
import {GesComponent as popup} from '@components/popup/ges/ges.component';
import {NoopScrollStrategy} from '@angular/cdk/overlay';

@Component({
    selector: 'app-ges',
    templateUrl: './ges.component.html',
    styleUrls: ['./ges.component.scss']
})
export class GesComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() extChange = new EventEmitter();
    panelColor = new UntypedFormControl('');

    constructor(
        private http: HttpClient,
        public commonService: CommonService,
        public dialog: MatDialog,
    ) {
    }

    ngOnInit(): void {
        if (this.extChange) {
            this.extChange.subscribe(data => {
                this.setData();
            });
        }
        this.setData();
    }

    setData() {
        this.panelColor.setValue(this.favorite.status);
    }

    popup() {
        const dialogRef = this.dialog.open(popup, {
            width: '1000px',
            scrollStrategy: new NoopScrollStrategy()
        });
    }
}
